import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './picture.scss';
import breakpoints from '../../theme/breakpoints';

// Style variation for tertiary picture is TBD

export const PictureComponent = ({
  id, src, styles, mobileSrc, mobileWebpSrc, desktopWebpSrc, alt, variant, ...rest
}) => {
  const tabletBp = `(max-width: ${breakpoints.values.medium}px)`;

  return (
  // TODO: Create a class and modifier(s) for nmx-picture in nmx-template. This is currently unsupported.
    <picture
    id={id}
    className={classnames('nmx-picture', `nmx-picture--${variant}`)}
    {...rest}>
      {mobileWebpSrc && <source
      srcSet={mobileWebpSrc}
      type="image/webp"
      media={tabletBp}
    />}
      {mobileSrc && <source
      srcSet={mobileSrc}
      media={tabletBp}
    />}
      {desktopWebpSrc && <source
      srcSet={desktopWebpSrc}
      type="image/webp"
    />}
      <img style={styles || {}} className='nmx-picture__image' src={src} alt={alt} />
    </picture>
  );
};

PictureComponent.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  styles: PropTypes.object,
  id: PropTypes.string,
  src: PropTypes.string.isRequired,
  mobileSrc: PropTypes.string,
  mobileWebpSrc: PropTypes.string,
  desktopWebpSrc: PropTypes.string,
  alt: PropTypes.string.isRequired,
};

PictureComponent.defaultProps = { variant: 'primary' };

export default PictureComponent;
